import React, { useMemo } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import Avatar from '@material-ui/core/Avatar';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useHistory } from 'react-router';
import { realRoleNames } from 'cassandra-shared-js/roles';
import { getTheme } from '../../../theme';
import { useAuth } from '../../../AuthCtx';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    borderRadius: 0,
    marginTop: -getTheme().spacing(1),
  },
})((props) => {
  return (
    <Menu
      elevation={ 0 }
      getContentAnchorEl={ null }
      anchorOrigin={ {
        vertical: 'bottom',
        horizontal: 'center',
      } }
      transformOrigin={ {
        vertical: 'top',
        horizontal: 'center',
      } }
      { ...props }
    />
  );
});

const StyledMenuItem = withStyles((theme) => {
  return {
    root: {
      '&:focus': {
        backgroundColor: theme.palette.primary.light,
        '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
          color: theme.palette.common.white,
        },
      },
    },
  };
})(MenuItem);

const useStyles = makeStyles((theme) => {
  return {
    menuButton: {
      borderRadius: 0,
      marginRight: -theme.spacing(3), // negative margin to cancel out the layout's padding
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      backgroundColor: theme.palette.alternate.main,
      height: '100%',
    },
  };
});

const AccountMenu = () => {
  const classes = useStyles();

  const [ anchorEl, setAnchorEl ] = React.useState(null);

  const { user } = useAuth();

  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAccount = () => {
    handleClose();
    history.push('/my-account');
  };

  const handleLogout = () => {
    handleClose();
    history.push('/logout');
  };

  const realRoleName = useMemo(() => {
    const foundRoleName = Object.values(realRoleNames).find((rl) => {
      return rl.value === user.role.name;
    });

    return foundRoleName?.name ?? user.role.name;
  }, [ user, realRoleNames ]);

  if (!user) { return null; }

  return (
    <>
      <Button
        className={ classes.menuButton }
        disableElevation
        disableRipple
        aria-controls='customized-menu'
        aria-haspopup='true'
        variant='contained'
        color='primary'
        onClick={ handleClick }
      >
        {user?.avatar?.url ? (
          <Avatar src={ `${ process.env.REACT_APP_API_URL }${ user.avatar.url }` } />
        ) : (
          <Avatar>
            {/* {`${ data?.name[0] || '' }${ data?.surname[0] || '' }`} */}
          </Avatar>
        )}
        <span style={ { margin: getTheme().spacing(0, 2) } }>
          {user.username}
          {' '}
          {`<${ realRoleName }>`}
        </span>
        <KeyboardArrowDownIcon />
      </Button>
      <StyledMenu
        id='customized-menu'
        anchorEl={ anchorEl }
        keepMounted
        open={ Boolean(anchorEl) }
        onClose={ handleClose }
      >
        <StyledMenuItem onClick={ () => { return handleAccount(); } }>
          <ListItemIcon>
            <AccountBoxIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText primary='My Account' />
        </StyledMenuItem>
        <StyledMenuItem onClick={ () => { return handleLogout(); } }>
          <ListItemIcon>
            <MeetingRoomIcon color='error' fontSize='small' />
          </ListItemIcon>
          <ListItemText primary='Logout' />
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};

export default AccountMenu;
